import styles from './styles.module.css';
import { Button, Icon } from '../../../../../components';
import { Icons } from '../../../../../components/Icon/Icon';
import selectionStyles from '../../../../../components/SelectionPopup/SelectionPopupBase/selection-popup.module.css';

const StorageCurrentStatus = ({ onSave, canSave, children, activeStates, handleClose }: any) => {
    return (
        <div className={selectionStyles.selectedBox}>
            <div className={styles.content}>
                <div className={styles.header}>
                    <h2> You stored structure:</h2>
                    <div>
                        {/*{children}*/}
                        {!!handleClose && (
                            <Button
                                onClick={handleClose}
                                size={'md'}
                                after={<Icon icon={Icons.closeRounded} />}
                                responsiveIcon={true}
                            >
                                Close
                            </Button>
                        )}
                    </div>
                </div>

                <div
                    className={`${styles.item} 
                    ${styles.horizontal} 
                    ${!!activeStates?.investors ? styles.active : ''}
                    `}
                >
                    <div
                        className={`${styles.box}
                            ${activeStates?.investors > 1 ? styles.multiple : ''}
                            `}
                    >
                        <div className={styles.boxInner}>
                            <Icon icon={Icons.investor} />
                        </div>
                    </div>
                    <h6>Investors</h6>

                    <span className={styles.arrow} />
                </div>
                <div className={styles.row}>
                    <div
                        className={`${styles.item} ${!!activeStates?.serviceProviders ? styles.active : ''}
                    `}
                    >
                        <h6>Service providers</h6>
                        <div
                            className={`${styles.box}
                            ${activeStates?.serviceProviders > 1 ? styles.multiple : ''}
                            `}
                        >
                            <div className={styles.boxInner}>
                                <Icon icon={Icons.serviceProvider} />
                            </div>
                        </div>
                        <span className={styles.arrow} />
                    </div>

                    <div
                        className={`${styles.item} ${!!activeStates?.assetManager ? styles.active : ''}
                    `}
                    >
                        <h6>Asset management</h6>
                        <div
                            className={`${styles.box}
                            ${activeStates?.assetManager > 1 ? styles.multiple : ''}
                            `}
                        >
                            <div className={styles.boxInner}>
                                <Icon icon={Icons.assetManagement} />
                            </div>
                        </div>
                        <span className={styles.arrow} />
                    </div>
                </div>

                <div
                    className={`${styles.item} 
                    ${styles.horizontal} 
                    ${styles.structure}
                    ${!!activeStates?.structure ? styles.active : ''}
                `}
                >
                    <div className={styles.box}>
                        <div className={styles.boxInner}>
                            <Icon icon={Icons.investment} />
                        </div>
                    </div>
                    <h6>Investment structure</h6>
                    <span className={styles.arrow} />
                </div>

                <div
                    className={`${styles.item} 
                    ${styles.horizontal} 
                    ${styles.last}
                    ${!!activeStates?.assets ? styles.active : ''}
                    
                `}
                >
                    <div
                        className={`${styles.box}
                            ${activeStates?.assets > 1 ? styles.multiple : ''}
                            `}
                    >
                        <div className={styles.boxInner}>
                            <Icon icon={Icons.asset} />
                        </div>
                    </div>
                    <h6>Assets</h6>
                </div>

                <div
                    className={`${styles.item} 
                    ${styles.other} 
                    ${activeStates?.other ? styles.active : ''}
                `}
                >
                    <div className={styles.box}>
                        <div className={styles.boxInner}>
                            <Icon icon={Icons.other} />
                        </div>
                    </div>
                    <h6>Other</h6>
                </div>
            </div>

            {!!onSave && (
                <div className={styles.footer}>
                    <Button disabled={!canSave} onClick={onSave}>
                        Save
                    </Button>
                </div>
            )}
        </div>
    );
};

export default StorageCurrentStatus;
